import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import { labelText } from "@cloudpivot/form/src/schema/system-data-item-codes";
import HLabel from "@cloudpivot/form/src/common/components/label.vue";
let ModifiedTime = class ModifiedTime extends Vue {
    render(h) {
        return h('h-label', { props: { text: labelText
            } });
    }
};
tslib_1.__decorate([
    Prop()
], ModifiedTime.prototype, "control", void 0);
ModifiedTime = tslib_1.__decorate([
    Component({
        name: 'ModifiedTime',
        components: {
            HLabel: HLabel
        }
    })
], ModifiedTime);
export default ModifiedTime;
